var map = {
	"./archibald/components/documents/Document": 51943,
	"./archibald/components/documents/Document.jsx": 51943,
	"./archibald/core/hooks/useDocumentFields": 41832,
	"./archibald/core/hooks/useDocumentFields.js": 41832,
	"./archibald/core/qes/constants": 18913,
	"./archibald/core/qes/constants.js": 18913,
	"./archibald/core/qes/documentProptypes": 93665,
	"./archibald/core/qes/documentProptypes.js": 93665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33319;